import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import { permissionsVar } from 'state/vars';

export const setPermissionsGroups = (groups: VisitorGroup[]) => {
  permissionsVar(groups);
};

export const setIsAdminGroupAction = (groupId: string) => {
  const currentGroups = permissionsVar();
  const updatedGroups = currentGroups.map((group) => {
    if (group.id === groupId)
      return {
        ...group,
        isAdminGroup: !group.isAdminGroup
      };
    return group;
  });
  permissionsVar(updatedGroups);
};

export const setIsQrCodeVisitInviterGroupAction = (groupId: string) => {
  const currentGroups = permissionsVar();
  const updatedGroups = currentGroups.map((group) => {
    if (group.id === groupId)
      return {
        ...group,
        isQrCodeVisitInviterGroup: !group.isQrCodeVisitInviterGroup
      };
    return group;
  });
  permissionsVar(updatedGroups);
};
